export default "__VITE_ASSET__BtF2HP2c__"